(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-pm-0088-interested"] && !Shopify.designMode) return;
  try {
    
  const urls = document.querySelectorAll('.pm-0088-item');

  const onClick = (e) => {
    e.preventDefault();
    const { href } = e.currentTarget;

    //Get the URLS
    const url = new URL(href);
    const params = new URLSearchParams(url.search);
    const filter = params.get('filter');

    if(!url || !params || !filter) {
      console.error("url", "params", "filter", url, params, filter);
    }

    //Check if filter is set
    if(filter) {
      Shopify.LocalStorage.set('rechargebundle_filters', [filter]);
    }

    //Redirect to url
    history.pushState({}, "", url);

    //Redirect
    window.location.replace(url);
  }

  console.log("pm-0088-interested", urls);

  urls.forEach((url) => url.addEventListener('click', onClick));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-pm-0088-introduction"] && !Shopify.designMode) return;
  try {
    
    if (!Element.prototype.scrollIntoViewIfNeeded) {
        Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded = true) {
            const el = this;
            new IntersectionObserver(function([entry]) {
                const ratio = entry.intersectionRatio;

                if(ratio < 1) {
                    let place = ratio <= 0 && centerIfNeeded ? 'center' : 'nearest';

                    el.scrollIntoView({
                        behavior: "smooth",
                        block: place,
                        inline: place,
                    });
                }

                this.disconnect();
            }).observe(this);
        };
    }

    const elementIsInView = (element) => {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth));
    }

    const contentItems = document.querySelectorAll('.pm-0088-infoSection-content-item');
    const bullets = document.querySelectorAll('.pm-0088-infoSection-pager .pm-0088-pager-circle');

    const activateBullets = (index) => {
        //Remove first all classes
        //bullets.forEach((bullet) => bullet.classList.remove('active'));

        //Add them
        bullets.forEach((bullet, i) => {
            if(i <= index) {
                bullet.classList.add('active');
            } else {
                bullet.classList.remove('active');
            }
        });
    }

    const onClick = (event, element) => {
        event.preventDefault();
        const href = element.getAttribute('href');
        const target = document.querySelector(href);

        if(!target) {
            return;
        }

        const index = [...bullets].indexOf(element)
        activateBullets(index);

        //Scroll Into view
        if(target.scrollIntoViewIfNeeded) {
            target.scrollIntoViewIfNeeded()
        } else if (target.scrollIntoView) {
            target.scrollIntoView({
                behavior: "smooth"
            });
        }
    }

    const onIntersection = (entries, observer) => {
        entries.forEach((entry, index) => {
		    if (entry.isIntersecting) {
                activateBullets(entry.target.dataset.index)
		    	entry.target.classList.add("active");
		    } else {
    			entry.target.classList.remove("active");
	    	}
	    });
    }

    //When in view, activate the bullets & lines
    contentItems.forEach((element) => {
        // Intersection Observer erzeugen
        const observer = new IntersectionObserver(onIntersection, {
            root: null,
	        rootMargin: '0px',
	        threshold: 1,
        });
        observer.observe(element);
    })

    //onClick Event
    bullets.forEach((element) => {
        element.addEventListener('click', (e) => onClick(e, element));
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactform-config"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', e => {
    const configNode = document.getElementById('contactform-config');
    const config = JSON.parse(configNode.dataset.config || '{}');

    const contactForm = document.getElementById('ContactForm');

    if (contactForm) { 
      const contactFormPhoneField = document.getElementById('ContactForm-phone');

      // prependix
      if (config.prependix) {
        contactFormPhoneField.removeAttribute('pattern');
        contactFormPhoneField.removeAttribute('autocomplete');
        contactFormPhoneField.setAttribute('type', 'text');
        contactFormPhoneField.setAttribute('placeholder', config.prependix);

        const contactFormPhoneFieldLabel = document.querySelector('#ContactForm #ContactForm-phone + label');
        contactFormPhoneFieldLabel.innerHTML = config.prependix;

        const contactFormText = document.getElementById('ContactForm-body');
        const contactFormSubmit = document.querySelector('#ContactForm .contact__button > button.button');
  
        var prependix = config.prependix + '\n\n------------------------------\n\n';
  
        contactForm.addEventListener('submit', e => {
            e.preventDefault();
        });
  
        contactFormSubmit.addEventListener('click', e => {
            let bodyText = contactFormText.value || '';
            contactFormText.value = prependix + bodyText;
            contactFormPhoneField.value = '007';
            contactForm.submit();
            contactFormText.value = bodyText;
            contactFormPhoneField.value = '';
        });
      }

      // hide field
      if (config.phoneFieldHide) {
        contactFormPhoneField.parentNode.style.display = 'none';
      }

      // disable field
      if (config.phoneFieldDisable) {
        contactFormPhoneField.setAttribute('disabled', 'disabled');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recharge-bundle-config"] && !Shopify.designMode) return;
  try {
    
  /* Recharge bundle customizations */
  (function () {
    var bundle,form,filters,mobileFilterMenuButtonIcon,mobileFilterMenuButtonTextNode,mobileFilterMenuButtonIconImage;

    const configNode = document.getElementById('recharge-bundle-config');
    const config = JSON.parse(configNode.dataset.config || '{}');

    // The moment build-a-box is available does not mean all other components are loaded also internally, yet.
    // So we wait until the form and filters are there.
    function boot() {
      const i = setInterval(function () {
        form = document.querySelector('#build-a-box .rb-sticky-form .rb-form');
        filters = document.querySelector('#build-a-box .rb-box-builder > .rb-filters');
    
        if (form && filters) {
          clearInterval(i);

          // now all components "should" be available, so move on

          // Add icon to mobile filter button
          if (config.customFilterButton === true) {
            mobileFilterMenuButtonIcon = 'data:image/png;base64,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';
            mobileFilterMenuButtonTextNode = document.querySelector('.rb-filters-nav > a > span');

            mobileFilterMenuButtonIconImage = document.createElement('img');
            mobileFilterMenuButtonIconImage.id = 'mobile-filter-menu-button-icon-image';
            mobileFilterMenuButtonIconImage.src = mobileFilterMenuButtonIcon;
            
            mobileFilterMenuButtonTextNode.insertAdjacentElement("beforebegin", mobileFilterMenuButtonIconImage);
          }

          // Change mobile filter button label
          if (config.customFilterButtonLabel.length > 0) {
            mobileFilterMenuButtonTextNode.innerHTML = config.customFilterButtonLabel || 'Mehr Filter';
          }

          // Move the filters into sticky area
          if (config.filterButtonInBar === true) {
            if (form.children.length > 0) {
              form.children[0].style.display = 'none';
              form.children[0].insertAdjacentElement("afterend", filters);
            }
          }

          // Utilize "externalFn" in recharge bundleapp "afterApp"-logic, to turn off the default /cart redirect
          window.RechargeBundle.onAddToCart = function () {
            return;
          }
        }
      }, 500);
    }

    // first, find the bundle component
    const i = setInterval(function () {
      bundle = document.getElementById('build-a-box');
  
      if (bundle) {
        clearInterval(i);
  
        boot();
      }
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();
})();
